import { useMemo } from 'react';

import { parseCssSizeVar } from '@xemplo/input-utils';

import { DrawerConfig } from '../drawer.types';

type UseDrawerDimensionsProps = Pick<DrawerConfig, 'width' | 'topOffset'>;

export function useDrawerDimensions({
  width = 488,
  topOffset = 0,
}: UseDrawerDimensionsProps) {
  return useMemo(
    () => ({
      style: {
        // TODO: We need to move this utility to its own library to avoid importing input utils here
        // It will be done in a separate PR as it will blow up the scope of this work.
        ...parseCssSizeVar('drawer-width', width),
        ...parseCssSizeVar('drawer-top-offset', topOffset),
      },
    }),
    [width, topOffset],
  );
}
